'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var PhotoDialog = require('./PhotoDialog.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var UploadPhotoButton = require('./UploadPhotoButton.js');
var CircularProgress = require('../../node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;
var styles = {
  tileButton: {
    cursor: 'pointer',
    align: 'center'
  },
  tileImage: {
    width: 110,
    height: 110,
    display: 'block',
    borderRadius: '5%',
    objectFit: 'cover'
  },
  progressContainer: {
    width: 110,
    height: 110
  }
};
var PhotoGridListParent = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(PhotoGridListParent, _PureComponent);

  function PhotoGridListParent(props) {
    var _this;

    classCallCheck(this, PhotoGridListParent);

    _this = possibleConstructorReturn(this, getPrototypeOf(PhotoGridListParent).call(this, props));
    _this.state = {
      focusedImage: {},
      focusedImageIndex: -1,
      disableBack: false,
      disableForward: false,
      isUploading: false
    };
    return _this;
  }

  createClass(PhotoGridListParent, [{
    key: "getErrorMessage",
    value: function getErrorMessage(error) {
      if (ObjectHelper.isPresent(error.response) && ObjectHelper.isPresent(error.response.data) && ObjectHelper.isPresent(error.response.data.error)) {
        return error.response.data.error;
      } else {
        return error.message;
      }
    }
  }, {
    key: "handlePhotoUpload",
    value: function handlePhotoUpload(event) {
      var _this2 = this;

      this.setState({
        isUploading: true
      });
      var photoList = Array.from(event.target.files);
      Promise.all(photoList.map(function (photo) {
        return _this2.props.uploadPhoto(photo).then(function () {
          return undefined;
        })["catch"](function (error) {
          return {
            error: _this2.getErrorMessage(error).message
          };
        });
      })).then(function (results) {
        return results.filter(function (result) {
          return ObjectHelper.isPresent(result) && result.hasOwnProperty('error');
        });
      }).then(function (errorMessages) {
        return errorMessages.map(function (errorMessage) {
          return errorMessage.error;
        });
      }).then(function (errors) {
        _this2.props.handlePhotoUploadError(errors);

        _this2.setState({
          isUploading: false
        });
      });
    }
  }, {
    key: "handlePhotoDelete",
    value: function handlePhotoDelete(photo) {
      this.props.deletePhoto(photo);
      this.setState({
        focusedImage: {}
      });
    }
  }, {
    key: "onBackClick",
    value: function onBackClick(photos, focusedImageIndex) {
      var newState = {
        disableBack: this.shouldBackBeDisabled(focusedImageIndex - 1),
        disableForward: this.shouldForwardBeDisabled(photos.length, focusedImageIndex - 1)
      };

      if (focusedImageIndex >= 0) {
        newState = Object.assign({}, newState, {
          focusedImage: photos[focusedImageIndex - 1],
          focusedImageIndex: focusedImageIndex - 1
        });
      }

      this.setState(newState);
    }
  }, {
    key: "onForwardClick",
    value: function onForwardClick(photos, focusedImageIndex) {
      var newState = {
        disableBack: this.shouldBackBeDisabled(focusedImageIndex + 1),
        disableForward: this.shouldForwardBeDisabled(photos.length, focusedImageIndex + 1)
      };

      if (focusedImageIndex < photos.length - 1) {
        newState = Object.assign({}, newState, {
          focusedImage: photos[focusedImageIndex + 1],
          focusedImageIndex: focusedImageIndex + 1
        });
      }

      this.setState(newState);
    }
  }, {
    key: "shouldBackBeDisabled",
    value: function shouldBackBeDisabled(index) {
      if (index <= 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "shouldForwardBeDisabled",
    value: function shouldForwardBeDisabled(length, index) {
      if (index >= length - 1) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "buildPhotoTiles",
    value: function buildPhotoTiles(photos) {
      var _this3 = this;

      var photoTiles = [];
      photos.map(function (photo, index) {
        photoTiles.push(React__default["default"].createElement(Grid, {
          item: true,
          key: index,
          className: _this3.props.classes.tileButton,
          onClick: function onClick() {
            _this3.setState({
              disableBack: _this3.shouldBackBeDisabled(index),
              disableForward: _this3.shouldForwardBeDisabled(photos.length, index),
              focusedImage: photo,
              focusedImageIndex: index
            });
          }
        }, React__default["default"].createElement("img", {
          src: photo.thumb_url,
          alt: photo.altText,
          className: _this3.props.classes.tileImage
        })));
      });
      return photoTiles;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          photos = _this$props.photos,
          canEdit = _this$props.canEdit,
          classes = _this$props.classes;
      var _this$state = this.state,
          focusedImage = _this$state.focusedImage,
          focusedImageIndex = _this$state.focusedImageIndex,
          disableBack = _this$state.disableBack,
          disableForward = _this$state.disableForward,
          isUploading = _this$state.isUploading;
      return React__default["default"].createElement(Grid, {
        container: true,
        justify: "center",
        alignItems: "center"
      }, React__default["default"].createElement(Grid, {
        item: true,
        xs: 12,
        container: true,
        spacing: 40
      }, this.buildPhotoTiles(photos), isUploading == true && React__default["default"].createElement(Grid, {
        item: true
      }, React__default["default"].createElement(Grid, {
        container: true,
        alignItems: "center",
        justify: "center",
        className: classes.progressContainer
      }, React__default["default"].createElement(Grid, {
        item: true
      }, React__default["default"].createElement(CircularProgress["default"], null)))), canEdit && isUploading == false && React__default["default"].createElement(Grid, {
        item: true
      }, React__default["default"].createElement(UploadPhotoButton, {
        handlePhotoUpload: function handlePhotoUpload(event) {
          _this4.handlePhotoUpload(event);
        }
      }))), React__default["default"].createElement(PhotoDialog, {
        focusedImage: focusedImage,
        open: ObjectHelper.isPresent(focusedImage),
        onClose: function onClose() {
          return _this4.setState({
            focusedImage: {}
          });
        },
        onDelete: function onDelete(photo) {
          return _this4.handlePhotoDelete(photo);
        },
        canEdit: canEdit,
        onBackClick: function onBackClick() {
          return _this4.onBackClick(photos, focusedImageIndex);
        },
        onForwardClick: function onForwardClick() {
          return _this4.onForwardClick(photos, focusedImageIndex);
        },
        disableBack: disableBack,
        disableForward: disableForward
      }));
    }
  }]);

  return PhotoGridListParent;
}(React.PureComponent)) || _class);
PhotoGridListParent.defaultProps = {
  photos: [],
  isMobile: false,
  canEdit: false,
  uploadPhoto: function uploadPhoto() {},
  deletePhoto: function deletePhoto() {},
  handlePhotoUploadError: function handlePhotoUploadError() {}
};

module.exports = PhotoGridListParent;
